// extracted by mini-css-extract-plugin
export default {"location":"NextItem-module-fb01d2bb82ccaea1d7cb","layout":"NextItem-module-e9ee0417b2dfabcb43ed"};